<div class="top-logo-bar" [class.hidden]="unAuthorized">
  <div></div>
  <div class="logo">
    <img
      src="assets\logo-ops.svg"
      class="menu-dot"
      (click)="onReturnToDashboard()"
    />
    <app-spinner></app-spinner>
  </div>
  <!-- <div class="account-menu">
    {{userInitials}}
  </div> -->
  <ops-user-menu></ops-user-menu>
</div>
